import { generateUUID } from './utils/uuid';

// Install before the application imports run: both Cloud and shared OSS
// components call crypto.randomUUID, including during module initialization.
// getRandomValues remains available on HTTP; native UUID generation is retained
// on HTTPS and localhost. This does not make an HTTP origin a secure context.
if (
  typeof globalThis.crypto?.getRandomValues === 'function' &&
  typeof globalThis.crypto.randomUUID !== 'function'
) {
  globalThis.crypto.randomUUID = generateUUID;
}
